import { render, staticRenderFns } from "./LoginStar.vue?vue&type=template&id=6a8886e5&scoped=true&"
import script from "./LoginStar.vue?vue&type=script&lang=js&"
export * from "./LoginStar.vue?vue&type=script&lang=js&"
import style0 from "./LoginStar.vue?vue&type=style&index=0&id=6a8886e5&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8886e5",
  null
  
)

export default component.exports